import { gql } from 'graphql-request';
import { groq } from 'next-sanity';

var Le=Object.defineProperty;var ie=Object.getOwnPropertySymbols;var we=Object.prototype.hasOwnProperty,Ae=Object.prototype.propertyIsEnumerable;var le=(t,r,i)=>r in t?Le(t,r,{enumerable:!0,configurable:!0,writable:!0,value:i}):t[r]=i,se=(t,r)=>{for(var i in r||(r={}))we.call(r,i)&&le(t,i,r[i]);if(ie)for(var i of ie(r))Ae.call(r,i)&&le(t,i,r[i]);return t};var Be=`
query getCommerce(
  $pids: String
  $locale: String
) {
  getCommerce(pids: $pids, locale: $locale) {
    multipleProducts {
      id
      product {
        data {
            id
            variants {
                productId
            }
        }
      }
    }
  }
}`;var L=`
  getPersonalizations(locale: $locale) {
    userPersonalizations {
      customerGroups
    }
  }
`,Re=gql`
  query CustomerGroups($locale: String) {
    ${L}
  }
`;var M=`
    id
    checkoutUrl
    amountForStartingSubscriptionCents
    currency
    monthlyAmountCents
    subscribedPlan {
      name
      showInPriceBreakDown
      plan {
        id
        slug
        monthlyAmountIncludingTaxCents
        initialAmountIncludingTaxCents
      }
    }
    orderedProducts {
      id
      quantity
      recurring
      totalAmountIncludingTaxCents
      product {
        priceCents
        title
        sku
        slug
      }
      plan {
        id
      }
    }
`,qe=`
mutation createCart($input: CreateCartInput!) {
  createCart(input: $input) {
    subscription {
      token
    }
  }
}
`,Qe=`
mutation updatePlan($input: UpdatePlanInput!) {
  updatePlan(input: $input) {
    subscription {
      ${M}
    }
  }
}
`,Ve=`
mutation createOrderedProduct($input: CreateOrderedProductInput!) {
  createOrderedProduct(input: $input) {
    orderedProduct {
      id
      quantity
      metadata
    }
    subscription {
      ${M}
    }
  }
}
`,Oe=`
query getSubscription($token: ID!) {
	getSubscription(token: $token) {
		${M}
	}
}
`,Ne=`
mutation destroyOrderedProduct($input: DestroyOrderedProductInput!) {
  destroyOrderedProduct(input: $input) {
    orderedProduct {
      id
    }
    subscription {
      ${M}
    }
  }
}
`,Ee=`
mutation updateOrderedProduct($input: UpdateOrderedProductInput!) {
  updateOrderedProduct(input: $input) {
    orderedProduct {
			id
      quantity
    }
  }
}
`,Ge=`
mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription(input: $input) {
    subscription {
      email
      customerReference
    }
    errors {
      path
      attribute
      message
    }
  }
}
`,Ue=`
mutation UpdateAddressDetails($input: UpdateAddressDetailsInput!) {
  updateAddressDetails(input: $input) {
    subscription {
      email
      customerReference
    }
    errors {
      path
      attribute
      message
    }
  }
}
`,Rt=(t,r,i,B)=>{var ne;return t==="updatePlan"&&r?{input:{planSlug:r.slug}}:t==="addToCart"&&r?{input:{orderedProduct:{slug:r.slug,quantity:(ne=r.quantity)!=null?ne:1}}}:(t==="updateSubscription"||t==="updateAddress")&&i&&B?{input:se({token:B},i)}:t==="updateQuantity"&&r?{input:{id:r.id,quantity:parseInt(String(r.quantity))}}:t==="removeItem"&&r?{input:{id:r.id}}:t==="createCart"?{input:{}}:t==="getCart"&&B?{token:B}:{}},qt={createCart:qe,updatePlan:Qe,addToCart:Ve,getCart:Oe,removeItem:Ne,updateQuantity:Ee,updateSubscription:Ge,updateAddress:Ue},Qt=`
query getSubscription($token: ID!) {
	getSubscription(token: $token) {
    id
    fullName
    address
    houseNumber
    city
    zipcode
    country
    chargeDayOfTheMonth
    activatedAt
    amountForStartingSubscriptionCents
    monthlyAmountCents
    paymentMethodSummary
    pspPaymentMethodDetails
    invoices {
      invoicedAt
    }
	}
}`;var Nt=`query getAccount {
  getAccount {
      user {
          identity {
              id
              firstName
              lastName
              country
              postalCode
          }
          profile {
              userTypeId
              phoneNumbers {
                  type
                  value
              }
              addresses {
                  address1
                  address2
                  city
                  state
                  country
                  postalCode
              }
          }
      }
      offers {
          userOfferID
          userId
          sn
          offerId
          offerStatusId
          offerName
          offerDesc
          couponId
          couponStatusId
          shipmentLabelSentDateTime
      }
  }
}`,Et=`mutation updateAccount($sonosId: String!, $offers: [OfferStatusUpdateInput]) {
  updateAccount {
      updateUserOffers(sonosId: $sonosId, offers: $offers) {
          offersError {
              offerName
          }
          offersSuccess {
              offerName,
              newStatus
              sn
          }
      }
  }
}`;var C=`
  asset {
    _ref
    _type
    _key
  }
  altText
`,w=`
  _type
  _key
  ${C}
  caption
`,a=`
  ${w}
  tags
  mediaTags
`,ce=`
  ${C}
  mediaOpacity
`;var ze=gql`
  query ProductCarousel($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            content {
              name
              externalDefaultVariantId
              overview
              descriptor
              slug {
                current
              }
              media {
                ${a}
              }
            }
            price
            productPromotions {
              promotionalPrice
            }
            variationAttributes {
              values {
                description
                name
                orderable
                value
              }
              id
              name
            }
            variants {
              price
              productId
              orderable
              variationValues {
                color
                amount
                length
              }
              product {
                data {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;var m=`
  variationAttributes {
    id
    name
    values {
      name
      value
      description
      orderable
    }
  }
`;var We=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            price
            showPrice
            productPromotions {
              promotionalPrice
            }
            content {
              externalDefaultVariantId
              slug {
                current
              }
              name
              productForm
              media {
                ${a}
              }
              externalId
              overview
              descriptor
            }
            variants {
              productId
              product {
                data {
                  id
                }
              }
              variationValues {
                color
              }
            }
            ${m}
          }
        }
      }
    }
  }
`;var h=`
... on SanityMediaImage {
  _type
  _key
  responsiveImages {
    _key
    _type
    image {
      ${w}
      mediaOpacity
    }
    mediaQuery
  }
}`;var pe=`
... on SanityMediaVideo {
  _type
  _key
  responsiveVideos {
    mediaQuery
    video {
      altText
      aspectRatio
      asset {
        url
        assetId
      }
      enableBackgroundVideo,
      enablePlayByDefault
      mediaOpacity
    }
  }
}`;var $=`
... on SanityNewLine {
  _type
  _key
  _inline
  children {
    text
  }
}
`,b=`
... on SanityInlineSvg {
  _type
  _key
  altText
  asset {
    _ref
    _type
  }
  inlineSvg
  responsiveSettings {
    _type
    colspan
    svgHeight
    mediaQuery
  }
  tags
}
`,v=`
... on SanitySpan {
  _type
  _key
  marks
  text
}
`,S=`
... on SanityLink {
  _type
  _key
  href
}
`;var k=`
... on SanitySonosSvg {
  _type
  _key
  altText
  ${C}
  inlineSvg
  responsiveSettings {
    mediaQuery
    colspan
    svgHeight
    _type
    _key
  }
  tags
}`;var R=`
... on SanityValuePropBubble {
  _type
  _key
  content {
    _key
    _type
    children {
      ... on SanitySpan {
        _type
        _key
        marks
        text
      }
      ... on SanityNewLine {
        _type
        _key
        _inline
        children {
          text
        }
      }
    }
    level
    listItem
    markDefs {
      ... on SanityLink {
        _type
        _key
        href
      }
      ... on SanityCtaAnnotation {
        _type
        _key
        altText
        buttonType
        buttonColor
        ctaColor
        isButton
        url
      }
      ... on SanityColorAnnotation {
        _type
        _key
        color
      }
    }
    style
  }
  orientation
}`;var Je=`
... on SanityCtaAnnotation {
  _type
  _key
  buttonType
  buttonColor
  ctaColor
  isButton
  url
}
`,P=`
... on SanityColorAnnotation {
  _type
  _key
  color
}`,q=`
... on SanityCompareChart {
  id
  disclaimers
  colorScheme {
    title
    value
  }
  _type
  responsiveSettings {
    bottomGap
    colspan
    mediaQuery
    topGap
    firstColumnColspan
    gutterGap
  }
  rows {
    isHeader
    cells {
      copy {
        ... on SanityBlock {
          _key
          _type
          children {
            ${$}
            ${v}
            ${b}
          }
          level
          listItem
          markDefs {
            ${S}
            ${Je}
            ${P}
          }
          style
        }
        ${h}
        ${R}
        ${k}
      }
      isCheckmarkCell
      isEmpty
    }
  }
}
`;var Q=`
... on SanityCtaAnnotation {
  _type
  _key
  buttonType
  buttonColor
  ctaColor
  isButton
  url
  openInNewTab
  modalTrigger {
    modalContent {
      ${q}
    }
    id
    colorScheme {
      title
      value
    }
  }
}
`,W=`
... on SanityFootnoteAnnotation {
  _key
  _rev
  _type
  footnoteRef {
    _id
    id
    content {
      ... on SanityBlock {
        _key
        _type
        children {
          ${$}
          ${v}
          ${b}
        }
        markDefs {
          ${S}
          ${Q}
          ${P}
        }
        level
        listItem
        style
      }
    }
  }
}
`,d=`
... on SanityBlock {
  _key
  _type
  children {
    ${$}
    ${v}
    ${b}
  }
  level
  listItem
  markDefs {
    ${S}
    ${Q}
    ${P}
    ${W}
  }
  style
}
`;var me=`
... on SanityRichContent {
  content {
    ${d}
    ${h}
    ${R}
    ${k}
  }
  cta {
    url
    openInNewTab
    showArrow
    isButton
    ctaColor
    copy
    buttonType
    buttonColor
    altText
    modalTrigger {
      modalContent {
        ${q}
      }
      id
      colorScheme {
        title
        value
      }
    }
  }
  _type
  _key
}
`;var de=`
  hotSpotConfig {
    _type
    hotSpots {
      _type
      _key
      activeByDefault
      content {
        ${d}
      }
      id
      x
      y
    }
  }
`;var ue=`
... on SanityScrollSequence {
  _type
  _key
  frames {
    _ref
    _key
  }
  aspectRatio
  enableHotSpots
  enableScrollLock
  ${de}
  scrollLock {
    _type
    endDelay
    frameDuration
    startDelay
  }
}
`;var ge=`
responsiveSettings {
   _key
  mediaQuery
  verticalOffset
  horizontalOffset
  minWidth
  maxWidth
  avatar
  tailStyle
  tailDirection
  tailOffset
}
`;var J=`
  _key
  _type
  ${ge}
  textBubbleContent {
    content {
       ${d}
    }
  }
`,ye=`
... on SanityTextBubble {
  ${J}
}
`;var fe=`
responsiveSettings {
  _key
  mediaQuery
  backgroundImage {
    ${w}
  }
  animationType
  verticalOffset
  horizontalOffset
}
`;var $e=`
... on SanitySpeechBubbleConversation {
  _key
  _type
  ${fe}
  dialogueBubbles {
    ${J}
  }
}
`;var u=`
${h}
${pe}
${me}
${ue}
${ye}
${$e}
`;var g=`
responsiveSettings {
  align
  alignToEdge
  animationBottomOffset
  animationTopOffset
  animations {
    _type
    animation
    direction
    duration
    startOffset
    runOnce
    value
  }
  _type
  colspan
  justify
  left
  mediaQuery
  textAlign
  top
  verticalPadding
  horizontalPadding
  fillContainer
}
`;var be=`
responsiveSettings {
  align
  _type
  bottomGap
  columnGap
  flexDirection
  flexWrap
  fillBackgroundToContentWidth
  inlineMiniModuleWidth
  gutterGap
  justify
  mediaQuery
  minHeight
  rowGap
  topGap
}
`;var Z=`
_type
_key
id
colorScheme {
  title
  value
}
borderRadius
contentBlocks {
  _key
  _type
  blocks {
    ${u}
  }
  ${g}
}
headline {
  ${g}
  blocks {
    ${u}
  }
}
${be}
isLinkEnabled
`,_=`
... on SanityContentModule {
${Z}
}
`;var j=`
... on SanityScheduledContentSlot {
  _type
  _key
  id
  scheduledContent {
      ... on SanityScheduledContentAsset {
          _type
          _key
          content {
            ${_}
          }
          releaseTarget {
              _id
              _type
              id
              releaseDate
              offlineDate
              siteId
          }
      }
  }
}`;var V=`
seo {
  metaDescription
  metaTitle
  ogDescription
  ogTitle
  twitterDescription
  twitterTitle
  shareGraphic {
    asset {
      _ref
      _key
    }
  }
}
scheduledSeo {
  seo {
    metaDescription
    metaTitle
    ogDescription
    ogTitle
    twitterDescription
    twitterTitle
    shareGraphic {
      asset {
        _ref
        _key
      }
    }
  }
  releaseTarget {
    id
    releaseDate
    offlineDate
  }
}
`;var ve=`
id
price
showPrice
productPromotions {
  promotionalPrice
}
variants {
  productId
  variationValues {
    color
    amount
    length
  }
  product {
    data {
      id
      inventory {
        backorderable
        inStockDate
        orderable
        preorderable
        ats
        stockLevel
        perpetual
      }
      price
      productPromotions {
        promotionalPrice
      }
      gaCategory
      gaProductName
    }
  }
}
variationAttributes {
  id
  name
  values {
    name
    value
  }
}
content(locale: $locale) {
  name
  slug { current }
  descriptor
  overview
  tags
  badges {
    id
    value
  }
}
reviewSummary(locale: $locale) {
  average_rating
}
`,I=`
productBadges {
  badgePositionDesktop
  badgePositionMobile
  badgeText {
    id
    value
  }
  colorScheme {
    title
    value
  }
  colorSchemeBadgeBackground {
    title
    value
  }
  releaseTarget {
    _id
    _type
    id
    releaseDate
    offlineDate
  }
}
`,Y=`
hits {
  managedProduct {
    creationDate
  }
  productId
  price
  variationAttributes {
    id
    values {
      value
    }
  }
  expandedProductData {
    ${ve}
    price
    filterData
    color
    filterTokenSetFeatures
    filterTokenSetProductTypes
    filterTokenSetRoomTypes
    inventory {
      backorderable
      inStockDate
      orderable
      preorderable
      ats
      stockLevel
      perpetual
    }
  }
  content(locale: $locale) {
    name
    externalDefaultVariantId
    slug { current }
    descriptor
    overview
    tags
    ${I}
    productTags {
      id
      value
    }
    media {
      ${a}
    }
  }
  representedProducts {
    id
    product(locale: $locale) {
      data {
        ${ve}
      }
    }
  }
}`,Ze=`
  query getCommerce(
    $cids: String
    $locale: String
  ) {
    ${L}
    getCommerce(cids: $cids, locale: $locale) {
      categories {
        data {
          id
          parentCategoryId
          showSubCatsOnPLP
          robotsContent
          content {
            name
            description
            slug { current }
            ${V}
            footnotesJumpLinkEnabled
            offline
            content {
              ${_}
              ${j}
            }
            inlineTiles {
              responsiveSettings {
                mediaQuery,
                position
              }
              content {
                ${_}
                ${j}
              }
            }
          }
          categories {
            id
            robotsContent
            showOnPLP
            content {
               name
               description
               slug { current }
            }
            products {
              hits {
                productId
                content {
                  media {
                  ${a}
                  }
                }
              }
            }
          }
          products {
            ${Y}
          }
        }
      }
    }
  }
`;var O=`
    productLength
    productHeight
    productWeight
    productWidth
`;var F=`
{
  ${d}
  ... on SanityMediaImage {
    _type
    _key
    responsiveImages {
      _type
      _key
      image {
        _key
        _type
        altText
        asset {
          _type
          _ref
          _key
        }
        caption
        mediaOpacity
      }
    }
  }
  ... on SanityValuePropBubble {
    _type
    _key
    content {
      _key
      _type
      children {
        ${$}
        ${v}
        ${b}
      }
      level
      listItem
      markDefs {
        ${S}
        ${Q}
        ${P}
        ${W}
      }
      style
    }
    orientation
  }
  ... on SanitySonosSvg {
    _type
    _key
    ${C}
    inlineSvg
    responsiveSettings {
      _key
      _type
      colspan
      svgHeight
      mediaQuery
    }
    tags
  }
}
`,K=`productFeatures {
  feature {
    copy
    disclaimer
    id
    icon {
      ${ce}
    }
    inlineSvg
    buckets
  }
}`,X=`productTechSpecs {
  techSpec {
    headline
    bodyCopy ${F}
    shortBodyCopy ${F}
    id
    category
    buckets
  }
}`,je=`
recommendations {
  id
  product {
    data {
      id
      content {
        name
        externalDefaultVariantId
        overview
        descriptor
        slug {
          current
        }
        media {
          ${a}
        }
        ${I}
      }
      price
      showPrice
      productPromotions {
        promotionalPrice
      }
      variationAttributes {
        values {
          description
          name
          orderable
          value
        }
        id
        name
      }
      variants {
        price
        productId
        orderable
        variationValues {
          color
          amount
          length
        }
        product {
          data {
            id
            price
          }
        }
      }
    }
  }
}
`,s=`
  inventory {
    backorderable
    inStockDate
    orderable
    preorderable
    ats
    stockLevel
    perpetual
  }
`,ee=`managedProduct {
  productBundles {
    id
    product {
      data {
        id
        content {
          name
          productForm
          slug {
            current
          }
          media {
            ${a}
          }
        }
      }
    }
  }
}`,te=`content {
  name
  descriptor
  slug {
    current
  }
  media {
    ${a}
  }
}`,Ye=`
  bundledProducts {
    product {
        id
        ${s}
    }
  }
`,oe=`
  id
  SKU
  VPN
  gtin
  price
  secondaryCTA_v2
  alternateModal
  localeDisableProduct
  gaCategory
  gaProductName
  productPromotions {
    promotionalPrice
  }
  bundledProducts {
    product {
        id
        ${te}
        ${ee}
        ${s}
    }
  }
  ${s}
`,Se=`
  bundleData {
    id
    bundledProducts {
      quantity
      product {
        id
        ${s}
        price
        ${ee}
        productPromotions {
          promotionalPrice
        }
        ${te}
      }
    }
  }
`,Ke=`
  query getCommerce(
    $pids: String
    $locale: String
  ) {
    ${L}
    getCommerce(pids: $pids, locale: $locale) {
      products {
        data {
          id
          PRPageIDTag
          price
          showPrice
          ${s}
          secondaryUserBenefitAssetList
          secondaryCTA_v2
          gaCategory
          alternateModal
          primaryCategory {
            data {
              content {
                name
                slug { current }
              }
              parentCategory {
                data {
                  content {
                    name
                    slug { current }
                  }
                }
              }
            }
          }
          reviewSummary {
            average_rating
            review_count
          }
          productPromotions {
            promotionalPrice
          }
          VPN
          gtin
          ${Ye}
          ${Se}
          variants {
            variationValues {
              color
              amount
              length
            }
            productId
            product {
              data {
                ${oe}
                ${te}
                ${ee}
                ${Se}
              }
            }
          }
          ${m}
          ${je}
          content {
            slug {
              current
            }
            externalId
            externalDefaultVariantId
            name
            productForm
            descriptor
            lang
            ${I}
            moreInfo ${F}
            footnotesJumpLinkEnabled
            disclaimers
            media {
              ${a}
            }
            overview
            type
            hideFeaturesAboveFold
            ${K}
            ${X}
            content {
              ... on SanityContentModule {
                id
              }
              ... on SanityCarousel {
                id
              }
            }
            twoUpProductUpsell {
              productLeftExternalId
              productRightExternalId
            }
            productCompare {
              id
              headline {
                ${g}
                blocks {
                 ${u}
                }
              }
              compareProducts {
                cta {
                  copy
                }
                enableCta
                features {
                  copy
                }
                product {
                  externalId
                  name
                  media {
                    ${a}
                  }
                }
              }
            }
            twoUpCompare {
              headline
              compareProduct {
                features {
                  feature
                }
                externalId
              }
              compareProductCta {
                url
                copy
                altText
              }
              pdpProduct {
                features {
                  feature
                }
                externalId
              }
            }

            ${V}
            ${O}
          }
          paymentUpsells {
            options {
              isEnabled
              ... on KlarnaOptions {
                isEnabled
                placementId
                renderInline
                url
              }
            }
            type
          }
          techSpecs
          features
          enableReviews
        }
      }
    }
  }
`;var Xe=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            price
            productPromotions {
              promotionalPrice
            }
            content {
              externalDefaultVariantId
              slug {
                current
              }
              name
              productForm
              media {
                ${a}
              }
              externalId
              overview
              descriptor
            }
            variants {
              productId
              product {
                data {
                  id
                  bundleData {
                    id
                    bundledProducts {
                      product {
                        id
                        ${s}
                      }
                    }
                  }
                  ${s}
                }
              }
              variationValues {
                color
              }
            }
            ${m}
          }
        }
      }
    }
  }
`;var et=`
_type
_key
id
columnGap
responsiveSettings {
  _key
  _type
  bottomGap
  colspan
  columnGap
  leftGutterGap
  mediaQuery
  minHeight
  topGap
}
colorScheme {
  title
  value
}
headline {
  ${g}
  blocks {
    ${u}
  }
}
items {
  _type
  _key
  contentBlocks {
    _key
    _type
    blocks {
      ${u}
    }
    ${g}
  }
  colorScheme {
    title
    value
  }
  tabNavigationLabel {
    id
    value
  }
  tabNavigationSvg {
    ${k}
  }
  flexDirection
  isLinkEnabled
}
hidePagination
hideArrows
firstItemPosition
focusAllItems
autoPlay
autoPlaySpeed
tabNavigation
}
`,_e=`
... on SanityCarousel {
 ${et}
`;var Fe=`
... on SanityHero {
  _type
  _key
  id
  colorScheme {
    title
    value
  }
  media {
    ... on SanityMediaVideo {
      _type
      _key
      responsiveVideos {
        _type
        _key
        mediaQuery
        video {
          altText
          aspectRatio
          enableBackgroundVideo
          mediaOpacity
          asset {
            url
            assetId
          }
        }
      }
    }
    ... on SanityMediaImage {
      _type
      _key
      responsiveImages {
        _type
        image {
          altText
          caption
          mediaOpacity
          asset {
            _ref
            _key
          }
        }
        mediaQuery
      }
    }
  }
  overlayContent {
    ${Z}
  }
  responsiveSettings {
    _key
    _type
    bottomGap
    mediaQuery
    topGap
  }
  isScrollLockEnabled
  scrollLockDuration
}
`;var tt=`
  query getCommerce(
    $pids: String
    $locale: String
  ) {
    getCommerce(pids: $pids, locale: $locale) {
      products {
        data {
          id
          content {
            externalId
            content {
              ${_}
              ${Fe}
              ${_e}
            }
            faqs {
              question ${F}
              answer ${F}
            }
            productGuideAccordion ${F}
          }
        }
      }
    }
  }
`;var ot=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            price
            showPrice
            productPromotions {
              promotionalPrice
            }
            content {
              name
              media {
                ${a}
              }
            }
          }
        }
      }
    }
  }
`;var rt=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      products {
        data {
          id
          ${s}
          content {
            externalDefaultVariantId
            slug { current }
            name
            overview
            descriptor
            media {
              ${a}
            }
            ${I}
          }
          price
          productPromotions {
            promotionalPrice
          }
          variationAttributes {
            values {
              name
              orderable
              value
            }
            id
            name
          }
          ${m}
          variants {
            variationValues {
              color
            }
            productId
            product {
              data {
                ${oe}
              }
            }
          }
        }
      }
    }
  }
`;var at=`
query SearchQuery($q: String, $locale: String) {
  getCommerce {
    searchProducts(q: $q, locale: $locale) {
      total
      ${Y}
    }
  }
}
`;var nt=`
query PopularTerms($locale: String) {
  getCommerce {
    searchTerms(locale: $locale) {
     terms
    }
  }
}`;var it=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        product {
          data {
            techSpecs
            features
            content{
              ${K}
              ${X}
              ${O}
            }
          }
        }
      }
    }
  }
`;var xe=`content {
  externalId
  name
  slug {
    current
  }
}`;var st=gql`
  query SubCategories(
    $cids: String
    $locale: String
  ) {
    getCommerce(cids: $cids, locale: $locale) {
      categories {
        data {
          categories {
            showInMenuMobile
            ${xe}
          }
        }
      }
    }
  }
`;var zr=`query getAccount {
  getAccount {
      user {
          identity {
              id
              luid
              auid
              email
              firstName
              lastName
              secured
              emailVerified
              emailVerificationGraceDate
              country
              postalCode
              preferredLanguage
          }
          registrationProfile {
              country
              postalCode
          }
          profile {
              userTypeId
              language
              phoneNumbers {
                  type
                  value
              }
              addresses {
                  address1
                  address2
                  city
                  state
                  country
                  postalCode
              }
          }
          subscriptions {
              softwareUpdate
              productInformation
              productResearch
              inAppMessaging
          }
      }
  }
}`;var ct=`
  query getCommerce($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            price
            showPrice
            productPromotions {
              promotionalPrice
            }
          }
        }
      }
    }
  }
`;var pt=`
  query getCommerce(
    $cids: String
    $locale: String
  ) {
    getCommerce(cids: $cids, locale: $locale) {
      categories {
        data {
          products {
            hits {
              productId
              expandedProductData {
                variants {
                  productId
                  product {
                    data {
                      id
                      color
                      price
                      name
                      SKU
                      content {
                        name
                        media {
                          ${a}
                        }
                      }
                      variationAttributes {
                        id
                        values {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;var dt=gql`
  query EnhancedProductCompare($pids: String, $locale: String) {
    getCommerce(pids: $pids, locale: $locale) {
      multipleProducts {
        id
        product {
          data {
            id
            price
            showPrice
            variationAttributes {
              id
              values {
                name
                value
              }
            }
            productPromotions {
              promotionalPrice
            }
          }
        }
      }
    }
  }
`;var Ce='!(_id in path("drafts.**"))';function e(t){return t?`coalesce(
        lang_refs[_key == $locale][0]->${t},
        lang_refs[_key == $fallbackLocale][0]->${t},
        lang_refs[lang == $locale][0].ref->${t}, 
        lang_refs[lang == $fallbackLocale][0].ref->${t}, 
        ${t}
      )`:`coalesce(
        lang_refs[_key == $locale][0]->,
        lang_refs[_key == $fallbackLocale][0]->, 
        lang_refs[lang == $locale][0].ref->, 
        lang_refs[lang == $fallbackLocale][0].ref->, 
        @
      )`}var N=`
_type == "leadForm" => {
      ...,
      cards[]{
          ...,
          panels[]{
              ...,
              formElements[]{
                ...,
                ...label->{
                "label": ${e("value")}
                },
                ...otherRequiredMessage->{
                "otherRequiredMessage": ${e("value")}
                },
                ...requiredMessage->{
                "requiredMessage": ${e("value")}
                },
                ...patternMessage->{
                "patternMessage": ${e("value")}
                },
                ...placeholder->{
                "placeholder": ${e("value")}
                },
                values[]{
                    ...,
                    ...label->{
                        "label": ${e("value")}
                    },
                }
              }
          },
          cta[]{
            ...,
            ...label->{
                "label": ${e("value")}
            },
            actions[]{
                ...,
                conditionalRedirectOnSuccess[]{
                    ...,
                    "page": @.page->slug.current
                },
                "defaultRedirectionOnSuccess": @.defaultRedirectionOnSuccess->slug.current,
            }
          }
      },
      milestones[]{
          ...,
          ...label->{
            "label": ${e("value")}
          }
      }
    }
`;var c=`
_type == "mediaVideo" => {
  _key,
  responsiveVideos[]{
    ...,
    video{
      ...,
      "asset":  @.asset->{...}
    }
  }
}
`;var T=`
_type == "sonosVideo" => {
    ...,
    "asset":  @.asset->{...}
  }
`;var y=`
...,
"inlineSvg": @.asset->content.data,
"tags": @.asset->opt.media.tags[]->name.current
`;var he=`
contentBlocks[]{
  ...,
  blocks[]{
    ...,
    content[]{
      ...,
      _type == "block" => {
        ...,
        children[]{
          ...,
          _type == "inlineSvg" => {
            ${y}
          }
        },
      },
      _type == "sonosSvg" => {
        ${y}
      },
      ${T},
    },
    ${N},
    ${c},
    _type == "blockForm" => {
      ...,
      form->{
        ...,
        fields[]{
          ...,
          formField->{
            ...,
            "label": label->value,
            options[]{
              "label": label->value,
              value,
            },
          },
          "requiredMessage": requiredMessage->value,
          pattern,
          "patternMessage": patternMessage->value,
        }
      }
    },

  }
}
`,E=`
...,
_type == "hero" => {
  _type,
  id,
  colorScheme,
  overlayContent {
    ...,
    ${he}
  },
  media[0]{
    ...,
    ${c}
  },
  responsiveSettings
},
_type == "contentModule" => {
  _type,
  id,
  colorScheme,
  headline,
  responsiveSettings,
  ${he}
},
`;var o=`
  $locale == "en-us" => @,
  coalesce(
    lang_refs[_key == $locale][0]->,
    lang_refs[_key == $fallbackLocale][0]->,
    lang_refs[lang ==  $locale][0].ref->,
    lang_refs[lang == $fallbackLocale][0].ref->,
    @)
`;var re=`
cta{
  ...copy->{
    "copy": ${e("value")}
  },
  isButton,
  showArrow,
  buttonType,
  url,
  openInNewTab,
  altText,
  ctaColor,
  buttonColor,
  modalTrigger->{
    _type,
    id,
    colorScheme,
    modalContent[]->{
      ...select(
        ${o}
      )
    }{
      ${E}
    }
  }
}
`;var G=`
preload == true => {
  "blurDataURL": asset->metadata.lqip,
  "placeholder": "blur"
}
`;var x=`
_type == "mediaimage" => {
  _key,
  responsiveImages[]{
    ...,
    image {
      ...,
      ${G}
    }
  }
}
`;var f=`
contentBlocks[]{
  ...,
  blocks[]{
    ...,
    content[]{
      ...,
      _type == "block" => {
        ...,
        children[]{
          ...,
          _type == "inlineSvg" => {
            ${y}
          },
          _type == "iconTextBlock" => {
            ...,
            icon{
              ${y}
            }
          }
        },
        markDefs[]{
          ...,
          _type == "ctaAnnotation" => {
            ...,
            modalTrigger->{
              _type,
              id,
              colorScheme,
              modalContent[]->{
                ...select(
                  ${o}
                )
              }{
                ${E}
              }
            }
          },
          _type == "footnoteAnnotation" => {
            ...,
            footnoteRef->{
              ...select(
                ${o}
              )
            }{
              _type,
              _id,
              id,
              content
            }
          }
        }
      },
      _type == "sonosSvg" => {
        ${y}
      },
      _type == "assetDownload" => {
        ...,
        download{
          ...,
          "asset": @.asset->{...}
        },
      },
      ${T}
    },
    ${re},
    ${c},
    ${x},
    _type == "blockForm" => {
      ...,
      ...ctaLabel->{
        "ctaLabel": ${e("value")}
      },
      form->{
        ...select(
          ${o}
        )
      }{
        ...,
        fields[]{
          ...,
          formField->{
            ...select(
              ${o}
            )
          }{
            ...,
            options[] {
              ...,
              ...label->{
                "label": ${e("value")}
              },
            },
            ...label->{
              "label": ${e("value")}
            },
            ...placeholder->{
              "placeholder": ${e("value")}
            }
          },
          ...requiredMessage->{
            "requiredMessage": ${e("value")}
          },
          ...patternMessage->{
            "patternMessage": ${e("value")}
          },
        }
      }
    },
    ${N},
    _type == "faqs" => {
      ...,
      headline,
      faqsList[]->{
        ...select(
          ${o}
        )
      }{
        ...,
        question[]{
          ...,
          _type == "assetDownload" => {
            ...,
            download{
              ...,
              "asset": @.asset->{...}
            }
          }
        },
        answer[]{
          ...,
          _type == "assetDownload" => {
            ...,
            download{
              ...,
              "asset": @.asset->{...}
            }
          }
        },
      }
    },
    _type == "card" => {
      _type,
      _key,
      bgColor {
        title,
        value
      },
      headerContent,
      bodyContent[]{
        ...,
        children[]{
          ...,
          _type == "iconTextBlock" => {
            ...,
            icon{
              ${y}
            }
          }
        }
      },
      footerContent {
        ...,
        ${re}
      }
    }
  }
}
`;var A=`
    _type,
    id,
    colorScheme,
    borderRadius,
    headline,
    responsiveSettings,
    backgroundImage,
    isLinkEnabled,
    ${f}
`;var l=`
  _type == "hero" => {
    _type,
    id,
    colorScheme,
    overlayContent {
      ...,
      isLinkEnabled,
      ${f}
    },
    media[0]{
      ...,
      ${c},
      ${x}
    },
    responsiveSettings,
    isScrollLockEnabled,
    scrollLockDuration
  },
  _type == "scheduledContentSlot" => {
    ...,
  },
  _type == "scrollingCards" => {
    _type,
    id,
    cards[]{
      ...
    }
  },
  _type == "hotspotRooms" => {
    _type,
    id,
    markersAlwaysVisible,
    rooms[]{
      ...
    }
  },
  _type == "carousel" => {
    _type,
    id,
    colorScheme,
    headline,
    responsiveSettings,
    hidePagination,
    hideArrows,
    firstItemPosition,
    focusAllItems,
    autoPlay,
    autoPlaySpeed,
    tabNavigation,
    items[]{
      ...,
      ${f},
      tabNavigationLabel->{
        id,
        "value": ${e("value")}
      },
      tabNavigationSvg {
        ...,
        "inlineSvg": @.asset->content.data,
        "tags": @.asset->opt.media.tags[]->name.current
      },
      flexDirection,
      isLinkEnabled,
    }
  },
  _type == "productCarousel" => {
    _type,
    _id,
    id,
    colorScheme,
    headline,
    responsiveSettings,
    hidePagination,
    hideArrows,
    firstItemPosition,
    focusAllItems,
    enableCarouselRail,
    "products": products[]->{
      _type,
      externalId,
      "name": ${e("name")},
      releaseYear,
      badges[]{
        colorScheme,
        badgeText->{
         "value": ${e("value")},
        }
      },
      productImage{
        asset
      }
    }
  },
  _type == "contentModule" => {
    ${A}
  },
  _type == "productCompare" && productCompareType == "enhancedCompare" => {
    _type,
    id,
    productCompareType,
    productList[]->{
      ...select(
        ${o}
      ){
        externalId,
        productHeight,
        productLength,
        productWeight,
        productWidth,
        name,
        overview,
        media[]{
          ...,
          "mediaTags": asset->opt.media.tags[]->name.current
        },
        "productFeatures": features[]{
          enhancedCompareDisplayOverride,
          feature->{
            ...select(
              ${o}
            ){
              id,
              enhancedCompareCopy
            }
          },
        },
        "productTechSpecs": techSpecs[]{
          enhancedCompareDisplayOverride,
          techSpec->{
            ...select(
              ${o}
            ){
              id,
              enhancedCompareCopy
            }
          }
        },
      }
    },
    defaultProductList[]->{
      externalId
    },
    headline,
    "compareCategoryList": *[_type == "compareCategory" && lang == 'en-us' && ${Ce}]{
      ...select(${o}){
        id,
        value,
        priority,
        featuresAndSpecs[]->{
          id
        }
      },
    }[defined(id)] | order(priority)
  },
  _type == "categoryLinks" => {
    _type,
    id,
    colorScheme,
    headline,
    responsiveSettings,
    categories[]->{
      externalId,
      slug,
      "name": ${e("name")},
      media,
    },
  },
  _type == "recommender" => {
    _type,
    id,
    questions[] {
      ...,
      answers[] {
        ...,
        effectors[] {
          _type == "recommenderMultiplier" => {
            ...
          },
          _type == "recommenderProduct" => {
            ...,
            product -> {
              externalId,
              externalDefaultVariantId,
              name,
              media
            }
          },
          _type == "recommenderRedirect" => {
            ...,
            "page": page->slug.current
          },
        }
      }
    },
    defaultProducts[] {
      ...,
      product -> {
        externalId,
        externalDefaultVariantId,
        name,
        media
      }
    },
    formHeadline,
    recommendationsHeadline,
    recommendationsContent[] -> {
      _type == "hero" => {
        _type,
        id,
        colorScheme,
        overlayContent {
          ...,
          ${f}
        },
        media[0]{
          ...,
          ${c},
          ${x}
        },
        responsiveSettings
      },
      _type == "contentModule" => {
        ${A}
      }
    },
    ...ctaLabel->{
      "ctaLabel": ${e("value")}
    },
    form->{
      ...select(
        ${o}
      )
    }{
      ...,
      fields[]{
        ...,
        formField->{
          ...select(
            ${o}
          )
        }{
          ...,
          options[] {
            ...,
            ...label->{
              "label": ${e("value")}
            },
          },
          ...label->{
            "label": ${e("value")}
          },
          ...placeholder->{
            "placeholder": ${e("value")}
          }
        },
        ...requiredMessage->{
          "requiredMessage": ${e("value")}
        },
        ...patternMessage->{
          "patternMessage": ${e("value")}
        },
      }
    },
    "cancelPage": cancelPage->slug.current,
    "successPage": successPage->slug.current
  },
  _type == "resources" => {
    _type,
    id,
    headline,
    resourceItems[]{
      ...,
      _type == "resource" => {
        ...,
        upload{
          ...,
          "asset": @.asset->{...}
        }
      }
    },
  },
  _type == "productTileGrid" => {
    _type,
    id,
    responsiveSettings,
    products[]->{
      externalId,
      externalDefaultVariantId,
      name,
      media,
    },
    customTiles[] {
      ...,
      image {
        ...,
        ${G}
      }
    }
  },
  _type == "businessProductsGrid" => {
    _type,
    id,
    businessProducts[]->{
      product -> {
        ...,
        productBadges[]{
          ...,
          ...badgeText->{
           "value": ${e("value")},
          }
        },
      },
      "slug": slug.current,
    }
  },
  _type == "expandingCallout" => {
    _type,
    id,
    bottomImages,
    topImages,
    responsiveSettings
  },
`;var D='"priority": select(lang == (*[_type == "language" && slug.current == $locale][0].fallback->slug.current) => 100, 0)';function n(t,r){return `(${t} == null || ${t} < coalesce($previewDate, now())) && (${r} == null || ${r} > coalesce($previewDate, now()))`}var ae=`
  navigationBuckets[]{
    id,
    name,
    collapseOnMobile,
    navigationItems[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
      ...,
      "image": image{
      ...,
        "inlineSvg": asset->content.data,
      },
      "slug": slug.current,
      "navigationMenu": select(
        count(navigationMenu.content) > 0 => navigationMenu{
          ...,
          subNavItems[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
            ...,
            "productOrCategoryOrContentPage": productOrCategoryOrContentPage->{
              ...select(
                ${e()}
              )
            }{
              "name": coalesce(name, title),
              "slug": slug.current
            },
            "slug": slug.current,
          },
          content[]{
            _type == 'reference' => @->{
              ...select(
                _type == 'scheduledContentSlot' => {
                  _type,
                  id,
                  scheduledContent[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
                    _type,
                    releaseTarget->{
                      id,
                      releaseDate,
                      offlineDate,
                    },
                    content->{
                      ...select(
                        ${o}
                      )
                    }{${A}}
                  }
                },
                ${o}
              ){${l}}
            },
            _type != 'reference' => {
              ...,
              contentBlocks[]{
                ...,
                blocks[]{
                  ...,
                  cta{
                    ...,
                    ...copy->{
                      "copy": ${e("value")}
                    },
                  },
                  _type == "subcategories" => {
                    category->{ externalId }
                  },
                  _type == "productList" => {
                    products[]->{
                      ...select(
                        ${o}
                      )
                    }{
                      name,
                      "slug": slug.current,
                      "media": media['plp' in @.tags]
                    }
                  }
                }
              }
            }
          }
        },
         count(navigationMenu.subNavItems) > 0 => navigationMenu{
          ...,
          subNavItems[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
            ...,
            "slug": slug.current,
          },
        },
        null
      ),
      "productOrCategoryOrContentPage": productOrCategoryOrContentPage->{
        ...select(
          ${e()}
        )
      }{
        "name": coalesce(name, title),
        "slug": slug.current
      },
      "modalId": @.modalTrigger->id,
    }
  }
`,U=t=>`
  *[_type == "navigation" && id == "${t}" && (lang == $locale || lang == $fallbackLocale)]{
    ${D},
    ${ae},
  } | order(priority)[0]
`;var p=t=>`"${t}": ${t}->{
    ...select(
      ${o}
    ){
      ${ae}
    }
  }`;var Cn=groq`*[_type == "businessProduct" && slug.current == $slug && (lang == $locale || lang == $fallbackLocale)]{
  "slug": @->slug.current,
  seo,
  ${p("headerOverride")},
  product -> {
    ...
  }, 
  overview,
  moreInfo,
  note,
  content[]->{
    ...select(
      ${o}
    )
  }{${l}}
}[0]
`;var Pn=groq`*[ _type == "language" && slug.current == $locale][0]{
  "fallback": fallback->slug.current
}.fallback`;var Ln=groq`{
  "footer": ${U("footer")}
}`;var Mn=groq`*[id in $formField && _type == "formField"][]
    {
      id,
      name,
      type,
      ...label->{
        "label": ${e("value")}
      },
      ...placeholder->{
        "placeholder": ${e("value")}
      },
      hasDynamicOptions,
      "options": options[]{
        ...label->{
          "label": ${e("value")},
        },
        value
      },
      lang,
      pattern
    }`;var H=`
  "enabled": liveAgentEnabled,
  "isOfflineSupportEnabled": liveAgentIsOfflineSupportEnabled,
  "buttonId": liveAgentButtonId,
  "salesforceLanguage": liveAgentSalesforceLanguage,
  "deploymentName": liveAgentDeploymentName,
  "devName": liveAgentDevName,
`;var On=groq`*[ _type == "language" && wwwEnabled == true].slug.current`,Nn=groq`*[_type == "language" && wwwEnabled == true]{
  "countryLangName": name,
  "pathCode": slug.current,
  "currency": coalesce(country->currency, "EUR"),
  "countryName": country->name,
  "icon": country->icon,
  "flag": country->flag, 
  "powerReviews": {
    "merchantID": powerReviewsMerchantId,
    "merchantGroupId": powerReviewsMerchantGroupId,
  },
  "liveAgent": {
    ${H}
  },
  sfcc_siteId,
  wwwNonTransactional,
  extWarrantyEnabled
}`;var Jn=groq`
{
  'page': *[_type == "contentPage" && slug.current == $slug && (lang == $locale || lang == $fallbackLocale)]{
    "priority": select(lang == $fallbackLocale => 100, 0),
    title,
    slug,
    seo,
    scheduledSeo[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
      seo,
      releaseTarget->{
        id,
        releaseDate,
        offlineDate,
      }
    },
    lang,
    footnotesJumpLinkEnabled,
    content[]->{
      ...select(
        _type == 'scheduledContentSlot' => {
          _type,
          id,
          scheduledContent[${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
            _type,
            releaseTarget->{
              id,
              releaseDate,
              offlineDate,
            },
            content->{
              ...select(
                ${o}
              )
            }{${l}},
          },
        },
        ${o}
      ){${l}}
    },
    ${p("headerOverride")},
    ${p("stickySubnav")}
  } | order(priority)[0]
}
`;var Yn=groq`*[_type == "music-service" && slug.current == $slug]{
  slug,
  title,
  logo {
    asset
  }
}[0]`;var z=`"priority": select(lang == (*[_type == "language" && slug.current == $locale][0].fallback->slug.current) =>
${e("priority")}, 100 + ${e("priority")})`;var Pe=groq`[
  *[_type in ['businessProduct', 'contentPage', 'product', 'category', 'testimonial', 'testimonialListing'] && slug.current == $slug && (lang == $locale || lang == $fallbackLocale) && ${n("ribbon->releaseTarget->releaseDate","ribbon->releaseTarget->offlineDate")}][defined(ribbon)][0].ribbon->{
  ${z},
  'content': ${e("content")},
  'colorScheme': ${e("colorScheme")},
  "id": ${e("id")},
  "lang": ${e("lang")},
  "excludedLocales": excludedLocales[]->slug.current
},
  *[_type == "ribbon" && customerGroup in $customerGroups && (lang == $locale || lang == $fallbackLocale) && ${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
  ${z},
  colorScheme,
  content,
  id,
  lang,
  'releaseDate': releaseTarget->releaseDate,
  "excludedLocales": excludedLocales[]->slug.current
} | order(coalesce(priority, 0) desc, coalesce(dateTime(releaseDate), dateTime('1900-01-01T00:00:00.00Z')) desc)[0],
*[_type == "ribbon" && isDefault && (lang == $locale || lang == $fallbackLocale) && ${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
  ${z},
  colorScheme,
  content,
  id,
  lang,
  'releaseDate': releaseTarget->releaseDate,
  "excludedLocales": excludedLocales[]->slug.current
}| order(coalesce(priority, 0) desc, coalesce(dateTime(releaseDate), dateTime('1900-01-01T00:00:00.00Z')) desc)[0]
][@.id != null && (@.excludedLocales == null || ( @.excludedLocales != null && !($locale in @.excludedLocales)))
][0]`;var gi=groq`{
  "currentLocale": *[_type == "language" && slug.current == $locale]{
    "pathCode": slug.current,
    "currency": coalesce(country->currency, "EUR"),
    "countryName": country->name,
    "countryLangName": name,
    "icon": country->icon,
    "flag": country->flag,
    "powerReviews": {
      "merchantID": powerReviewsMerchantId,
      "merchantGroupId": powerReviewsMerchantGroupId,
    },
    "liveAgent": {
      ${H}
    },
    sfcc_siteId,
    wwwNonTransactional,
    extendFeatureEnabled,
    extendInlineOfferingEnabled,
    extendInterstitialModalEnabled,
    extendLookbackEnabled,
    extendLookbackStartDate,
    extendLookbackEndDate,
    sonosFactoryWarrantyDays
  }[0],
  "svgs": *[_type == "sanity.imageAsset" && originalFilename in $svgIds]{
    ...,
    "inlineSvg": content.data,
    "tags": opt.media.tags[]->name.current
  },
  "microcopies": *[ id in $microcopyIds && _type == "content"].microcopy[]->{
    "key": id,
    "value": ${e("value")}
  },
  "forms": *[id in $formIds && _type == "form" && (lang == $locale || lang == $fallbackLocale)]{
    id,
    fields[]{
      name,
      "type": coalesce(type, "hidden"),
      ...formField->{
        ...select(${o})
      }{
        id,
        name,
        type,
        hasDynamicOptions,
        ...label->{
          "label": ${e("value")}
        },
        pattern,
        ...placeholder->{
          "placeholder": ${e("value")}
        },
        options[]{
          ...select(
            ${o}
          ){
            ...label->{
              "label": ${e("value")},
            },
            value
          }
        }
      },
      defaultValue,
      "readOnly": isReadOnly,
      ...requiredMessage->{
        "required": ${e("value")}
      },
      ...patternMessage->{
        "patternMessage": ${e("value")}
      }
    }
  },
  "dtcValueProps": *[_type == "contentModule" && (id == "dtc-value-props" || dtcValuePropsConfig.isDtcValuePropsModule == true) && (lang == $locale || lang == $fallbackLocale) && ${n("dtcValuePropsConfig.dtcValuePropsModuleReleaseTarget->releaseDate","dtcValuePropsConfig.dtcValuePropsModuleReleaseTarget->offlineDate")}]{
    "dtcValuePropsPriority": select(lang == $fallbackLocale => 100, 0),
    "releaseDate": dtcValuePropsConfig.dtcValuePropsModuleReleaseTarget->releaseDate,
    ${l}
  } | order(coalesce(dtcValuePropsPriority, 0), coalesce(dateTime(releaseDate), dateTime('1900-01-01T00:00:00.00Z')) desc)[0],
}`,yi=groq`{
  "header": ${U("header")},
  "ribbon": ${Pe},
}`;var $i=`*[_type == "product"]{
  externalId,
  "slug": slug.current,
  "locale": lang
}`;var vi=`*[_type == "category"]{
	"slug": slug.current,
  externalId
}`;var xi=groq`*[_type == "navigation" && id == "header" && (lang == $locale || lang == $fallbackLocale)]{
  ${D},
  navigationBuckets[]{
    id,
    navigationItems[] {
      navigationMenu {
        content[] {
          contentBlocks[] {
            blocks[] {
              _type,
              _type == "productList" => {
                products[]->{
                  externalId
                }
              }
            }
          }
        }
      }
    }
  }
} | order(priority)[0]`;var ki=groq`*[ _type == "language" && wwwEnabled == true && wwwPrerender == true].slug.current`;var Ti=groq`*[ _type == "product" && prerender == true && lang == "en-us"].externalId`;var wi=groq`*[ _type == "category" && prerender == true && lang == "en-us"].externalId`;var Te='(*[_type == "language" && slug.current == $locale][0].fallback->slug.current)',De='(*[_type == "language" && slug.current == $locale][0].fallback->fallback->slug.current)';var qi=groq`coalesce(
 *[ _type == "redirect" && lang == $locale && sourceSlug == $sourceSlug ]{
    "locale": lang,
    redirectType,
    sourceSlug,
    destinationSlug,
    sourceExternal,
    destinationExternal,
  }[0],
 *[ _type == "redirect" && lang == ${Te} && sourceSlug == $sourceSlug ]{
    "locale": lang,
    redirectType,
    sourceSlug,
    destinationSlug,
    sourceExternal,
    destinationExternal,
  }[0],
  *[ _type == "redirect" && lang == ${De} && sourceSlug == $sourceSlug ]{
    "locale": lang,
    redirectType,
    sourceSlug,
    destinationSlug,
    sourceExternal,
    destinationExternal,
   }[0]
)
`;var Hi=groq`*[_type == "splashPage" && id == $id && (lang == $locale || lang == $fallbackLocale) && ${n("releaseTarget->releaseDate","releaseTarget->offlineDate")}]{
    ${D},
    _type,
    id,
    colorScheme,
    overlayContent {
      ...,
      ${f}
    },
    media[0]{
      ...,
      ${c},
      ${x}
    },
} | order(priority)[0]`;var Ji=groq`
*[_type == "sanity.imageAsset" && originalFilename in $originalFilenames]{
    ...,
    "inlineSvg": content.data,
    "tags": opt.media.tags[]->name.current
  }
`;var Xi=groq`*[_type == "testimonial" && slug.current == $slug && (lang == $locale || lang == $fallbackLocale)]{
  ...,

  ${p("headerOverride")},

  authors[]->{
    name,
    "slug": slug.current,
    bio,
    image
  },

  bodyCopy[] {
    ...,
    ${T}
  },

  relatedTestimonials[]->{
    authorName,
    authorPosition,
    bodyCopy,
    mainImage,
    seo,
    "slug": slug.current,
    title
  }

}[0]
`;var rl=groq`*[_type == "testimonialGlobalContent" && (lang == $locale || lang == $fallbackLocale)]{
  content[]->{
    ${l}
  },
}[0]
`;var sl=groq`*[_type == "testimonialListing" && (lang == $locale || lang == $fallbackLocale)]{
  seo,
  ${p("headerOverride")},
  content[]->{
    ${l}
  },
}[0]
`;var ml=groq`*[_type == "testimonial" && !(_id in path('drafts.**')) && (lang == $locale || lang == $fallbackLocale)]{
  ...,
  "relatedTestimonials": [],
  "slug": slug.current
} | order(order)
`;var gl=groq`*[ _type == "language" && slug.current == $locale]{
  zuora_communicationProfile,
  "zuora_enabled": coalesce(zuora_enabled, false),
  zuora_pageId,
  zuora_invoiceTemplate,
  zuora_legalEntity,
  zuora_paymentGateway,
  zuora_sequenceSet,
  zuora_term,
  zuora_countryBlacklist
}`;

export { Ce as NotInDraftStatus, o as TranslatedDocumentFromReferenceFragment, e as TranslationFragment, Nn as allLocalesQuery, Cn as businessProductBySlug, it as compareProductsQuery, Rt as constructVariablesByAction, Re as customerGroupsQuery, dt as enhancedProductCompareQuery, Pn as fallbackLocaleQuery, pt as flexProductsQuery, Ln as footerQuery, Mn as formFieldsData, qt as getQueryByAction, st as getSubCategories, Qt as getSubscriptionBillingQuery, On as localesQuery, Yn as musicServiceQuery, Et as myAccountUpdateUserOffers, Nt as myAccountUserOffersQuery, zr as myAccountUserQuery, Jn as pageBySlug, gi as pageDataQuery, yi as pageHeaderRibbonQuery, tt as pdpAdditionalContentQuery, Ke as pdpQuery, $i as pdpRewriteSlugsQuery, Be as pdpRewritesQuery, Ze as plpQuery, vi as plpRewritesQuery, xi as prefetchNavPdpQuery, ki as prerenderLocalesQuery, Ti as prerenderPdpsQuery, wi as prerenderPlpsQuery, ze as productCarouselQuery, ct as productCompareQuery, We as productTile, Xe as productTileFlexQuery, qi as redirectForLocaleAndSlugQuery, Pe as ribbonQuery, nt as searchPopularTermsQuery, at as searchQuery, Hi as splashPageQuery, Ji as svgsByFilenames, Xi as testimonialBySlug, rl as testimonialGlobalContent, sl as testimonialListing, ml as testimonialsAll, ot as twoUpCompare, rt as twoUpProductUpsell, gl as zuoraSettingsQuery };
